import type { ThemeDefinition } from './types';

export const formal: ThemeDefinition = {
  fontsUrl:
    'https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;1,400&family=Inter:wght@400;500;600&display=swap',
  variables: {
    '--report-font-display': "'Playfair Display', Georgia, serif",
    '--report-font-body': "'Inter', system-ui, sans-serif",
    '--report-bg': '#fefdfb',
    '--report-bg-surface': '#faf7f2',
    '--report-text': '#2c2418',
    '--report-text-secondary': '#6b5d4a',
    '--report-text-muted': '#a69880',
    '--report-accent': '#c9a96e',
    '--report-accent-dim': 'rgba(201, 169, 110, 0.12)',
    '--report-border': '#e0d5c4',
    '--report-border-strong': '#c9bba5',
    '--report-stat-color': '#2c2418',
    '--report-stat-positive': '#16a34a',
    '--report-stat-negative': '#dc2626',
    '--report-callout-bg': '#faf7f2',
    '--report-callout-border': '#c9a96e',
    '--report-surface-hover': '#f0ede6',
    '--report-measure': '780px',
  },
};
